import { BookingStatuses } from "../models/booking";

export class GeneralUtils {
    public static isBookingUnpaid(booking) {
        if (!booking) {
            return false;
        }
        if (
            [
                BookingStatuses.Canceled,
                BookingStatuses.SearchingDrivers,
                BookingStatuses.PendingDriverToChooseTime,
                BookingStatuses.Accepted,
                BookingStatuses.Arrived,
                BookingStatuses.InTransit,
                BookingStatuses.EndIntend,
                BookingStatuses.WaitForPayment,
            ].includes(booking.status)
        ) {
            return false;
        }

        if (booking.payment?.priceBoost) {
            if (
                booking.payment.priceBoost.status !==
                    BookingStatuses.Confirmed &&
                booking.payment.priceBoost.status !== BookingStatuses.Refunded
            ) {
                return true;
            }
        }
        if (booking.payment?.priceRide) {
            if (!booking.payment.priceRide?.transactionLog) {
                return false;
            }

            if (
                booking.payment.priceRide.status !==
                    BookingStatuses.Confirmed &&
                booking.payment.priceRide.status !== BookingStatuses.Refunded
            ) {
                return true;
            }
            return false;
        }
        if (!booking.payment?.priceBoost || !booking.payment?.priceRide) {
            return false;
        }
        return false;
    }
}